document.addEventListener('DOMContentLoaded', function () {
	if (typeof jQuery === 'undefined') return;

	var $gallery = jQuery('.grid__item.medium-up--one-half.product-gallery-fixed');
	var $wrapper = jQuery('.product__wrapper');
	if (!$gallery.length || !$wrapper.length) return;

	var $bounds = $wrapper.find('.product__page');
	if (!$bounds.length) $bounds = $wrapper;

	// Positioning context for the pinned end state
	$bounds.css('position', 'relative');

	var headerHeight, topOffset, galleryWidth, galleryHeight, galleryLeft, galleryLeftRel;
	var $spacer = null;
	var stickyActive = false;
	var state = 'natural'; // 'natural' | 'fixed' | 'absolute'

	function spacerStyles() {
		return {
			display: 'block',
			width: galleryWidth,
			height: galleryHeight,
			'flex-shrink': 0
		};
	}

	function setState(newState) {
		if (state === newState) return;
		state = newState;

		if (newState === 'natural') {
			$gallery.css({ position: '', top: '', left: '', width: '', bottom: '', visibility: '' });
			if ($spacer) $spacer.hide();

		} else if (newState === 'fixed') {
			if (!$spacer) {
				$spacer = jQuery('<div aria-hidden="true">');
				$gallery.after($spacer);
			}
			$spacer.css(spacerStyles());
			$gallery.css({
				position: 'fixed',
				top: topOffset + 'px',
				left: galleryLeft + 'px',
				width: galleryWidth + 'px',
				bottom: 'auto',
				visibility: ''
			});

		} else {
			// Pin gallery to the bottom of the product box, then scroll away with the page
			if (!$spacer) {
				$spacer = jQuery('<div aria-hidden="true">');
				$gallery.after($spacer);
			}
			$spacer.css(spacerStyles());

			var boundsHeight = $bounds.outerHeight();
			$gallery.css({
				position: 'absolute',
				top: (boundsHeight - galleryHeight) + 'px',
				left: galleryLeftRel + 'px',
				width: galleryWidth + 'px',
				bottom: 'auto',
				visibility: ''
			});
		}
	}

	function update() {
		var scrollTop = jQuery(window).scrollTop();
		var boundsTop = $bounds.offset().top;
		galleryHeight = $gallery.outerHeight();

		var stickyStart = boundsTop - topOffset;
		var boundsBottom = boundsTop + $bounds.outerHeight();
		var stickyEnd = boundsBottom - topOffset - galleryHeight;

		if (scrollTop < stickyStart) {
			setState('natural');
		} else if (scrollTop >= stickyEnd) {
			setState('absolute');
		} else {
			setState('fixed');
		}
	}

	function cacheDimensions() {
		setState('natural');
		galleryWidth = $gallery.outerWidth();
		galleryHeight = $gallery.outerHeight();
		galleryLeft = $gallery.offset().left;
		galleryLeftRel = galleryLeft - $bounds.offset().left;
	}

	function init() {
		headerHeight = jQuery('#header').outerHeight() || 121;
		topOffset = headerHeight + 20;
		cacheDimensions();
		jQuery(window).on('scroll.stickyGallery', update);
		jQuery(window).on('resize.stickyGallery', function () {
			cacheDimensions();
			update();
		});
		update();
		stickyActive = true;
	}

	function destroy() {
		jQuery(window).off('scroll.stickyGallery resize.stickyGallery');
		setState('natural');
		if ($spacer) {
			$spacer.remove();
			$spacer = null;
		}
		$bounds.css('position', '');
		stickyActive = false;
	}

	if (window.innerWidth >= 990) init();

	jQuery(window).on('resize', function () {
		var isDesktop = window.innerWidth >= 990;
		if (isDesktop && !stickyActive) {
			init();
		} else if (!isDesktop && stickyActive) {
			destroy();
		} else if (isDesktop && stickyActive) {
			cacheDimensions();
			update();
		}
	});
});
(function ($) {
	"use strict";

	var splitTwoColumnBlockSectionRegistered = false;

	function initChallengeAnchor() { 
		var form = $('body#challenge form[action$="/contact"]');

		if (form.length < 1) {
			return;
		}

		form[0].action += "#newsletter";
	}

	function initListCollectionsProducts() {
		$(".js-list-collections-products").each(function (index, element) {
			var $element = $(element);
			var $buttons = $("[data-handle]");
			var $products = $("[data-collection-handle]");

			$element.on("click", function (event) {
				var $target = $(event.target);
				var handle = $target.data("handle");

				if (handle == null) {
					return;
				}

				$buttons.removeClass("is-active");
				$buttons
					.filter("[data-handle='" + handle + "']")
					.addClass("is-active");

				if (handle === "*") {
					$products.show();
				} else {
					$products.hide();
					$products
						.filter("[data-collection-handle='" + handle + "']")
						.show();
				}
			});
		});
	}

	function initSplitTwoColumnBlockVideos($scope) {
		if (!$.fn.magnificPopup) {
			return;
		}

		$('[data-split-two-column-block-video]', $scope).magnificPopup({
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			closeBtnInside: false,
			preloader: false,
			fixedContentPos: false,
			iframe: {
				patterns: {
					youtube: {
						src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0&showinfo=0'
					},
					vimeo: {
						src: '//player.vimeo.com/video/%id%?autoplay=1'
					}
				}
			}
		});
	}

	function initSplitTwoColumnBlockSection() {
		if (splitTwoColumnBlockSectionRegistered) {
			return;
		}

		if (window.broadcast__sections && window.theme) {
			theme.SplitTwoColumnBlock = function (container) {
				this.$container = $(container);
				initSplitTwoColumnBlockVideos(this.$container);
			};

			theme.SplitTwoColumnBlock.prototype.onUnload = function () {
				this.$container.find('[data-split-two-column-block-video]').off('click.magnificPopup');
			};

			window.broadcast__sections.register('split-two-column-block', theme.SplitTwoColumnBlock);
			splitTwoColumnBlockSectionRegistered = true;
			return;
		}

		initSplitTwoColumnBlockVideos(document);
		$(document).on('shopify:section:load', function (event) {
			initSplitTwoColumnBlockVideos(event.target);
		});
		splitTwoColumnBlockSectionRegistered = true;
	}

	$(function () {
		initChallengeAnchor();
		initListCollectionsProducts();
		initSplitTwoColumnBlockSection();
	});
})(jQuery);
